import { Webhook } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { AddOrEditWebhookForm } from '@/components/modules/Webhooks/components/AddOrEditWebhookForm';
import { addOrEditWebhooksFormValues } from '@/components/modules/Webhooks/constants/addOrEditWebhooksFormValues';
import { useWebhooks } from '@/components/modules/Webhooks/hooks/useWebhooks';
import {
  AddOrEditWebhookFormSchema,
  AddOrEditWebhookFormType,
} from '@/components/modules/Webhooks/schemas/AddOrEditWebhookForm.schema';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';

export type EditWebhookDialogProps = {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
  userId: string;
  webhook: Webhook;
};

export const EditWebhookDialog = ({ opened, setOpened, toggleDialog, userId, webhook }: EditWebhookDialogProps) => {
  const { editWebhook, loading } = useWebhooks(userId);

  const onSubmit = async (formValues: AddOrEditWebhookFormType) => {
    await editWebhook(formValues, webhook.id);
    toggleDialog();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'EDIT_WEBHOOK'}
      onSubmitForm={onSubmit}
      isLoading={loading}
      defaultValues={addOrEditWebhooksFormValues({ webhook })}
      formSchema={AddOrEditWebhookFormSchema}
    >
      <>
        <AddOrEditWebhookForm fieldVariant={FieldVariant.form} fullWidth />
      </>
    </EditDialogWrapper>
  );
};
